import { threads } from '@webclient/lib/agent';

import { GenerateIconsRequestType } from '@webclient/shared-types/threads';

import { useMutation } from '@tanstack/react-query';

type Props = {
  onError?: (
    error: Error,
    variables: GenerateIconsRequestType,
    context: unknown,
  ) => Promise<unknown> | unknown;
};

export default function useGenerateIcons({ onError }: Props) {
  return useMutation({
    mutationKey: ['generateIcons'],
    mutationFn: async (params: GenerateIconsRequestType) => {
      const { data } = await threads.generateIcons(params);
      return data;
    },
    onError,
  });
}
